import { struct, union } from 'io-ts/Decoder';

import { Id as OrganizationId } from '../../../../organization/Id';
import { Id as FormulaID } from '../../../../whole-house/formula/Id';

export const Request = union(
	struct({
		organizationId: OrganizationId,
	}),
	struct({
		formulaId: FormulaID,
	})
);
